function toggleDesktopDetails() {

  const detailsList = document.querySelectorAll('details.desktop');

  console.log("checking elements");

  if(detailsList.length === 0){ 
    console.log("elements not found");
    return;
  }

  detailsList.forEach(function(details){

    if (window.innerWidth > 1200) {
      details.setAttribute('open', '');
      details.classList.add('is-open'); 
      console.log("OPEN applied", details);
    } else {
      details.removeAttribute('open');
      details.classList.remove('is-open');
    }

  });
}

/* Run after DOM is ready */
document.addEventListener("DOMContentLoaded", toggleDesktopDetails);

/* Also on resize */
window.addEventListener("resize", toggleDesktopDetails);

